export default "__VITE_ASSET__CdGFa7hv__"